import { KEYS, NAMESPACE } from "./i18n/clientCredentialExpirationOptions.i18n";

export function CREDENTIAL_LIFETIME_OPTIONS($app) {
    return [
        { text: $app.res({ key: KEYS.oneWeek, namespace: NAMESPACE }), value: 0 },
        { text: $app.res({ key: KEYS.oneMonth, namespace: NAMESPACE }), value: 1 },
        { text: $app.res({ key: KEYS.oneYear, namespace: NAMESPACE }), value: 2 },
        { text: $app.res({ key: KEYS.fiveYears, namespace: NAMESPACE }), value: 3 },
        { text: $app.res({ key: KEYS.indefinite, namespace: NAMESPACE }), value: 4 }
    ];
}
